export default __webpack_public_path__ + "static/media/mars_diffuse.33960f5a.jpg";